"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.substituteInScheme = exports.composeSubstitutions = exports.substituteInContext = exports.substituteInType = exports.EMPTY_SUBSTITUTION = void 0;
const type_1 = require("./types/type");
const util_1 = require("../util");
const builders_1 = require("./types/builders");
exports.EMPTY_SUBSTITUTION = {};
function substituteInType(sub, type) {
    switch (type.kind) {
        case type_1.TypeKind.Function:
            return builders_1.functionType(substituteInType(sub, type.input), substituteInType(sub, type.output));
        case type_1.TypeKind.Variable:
            return sub[type.name] || type;
        case type_1.TypeKind.Number:
            return type;
        case type_1.TypeKind.Boolean:
            return type;
        case type_1.TypeKind.BigInt:
            return type;
        case type_1.TypeKind.Character:
            return type;
        case type_1.TypeKind.Polymorphic:
            return builders_1.polymorphicType(type.constructor, type.parameters.map(type => substituteInType(sub, type)));
        default:
            util_1.assertUnreachable(type);
    }
}
exports.substituteInType = substituteInType;
function substituteInContext(sub, context) {
    const substitute = (scheme) => substituteInScheme(sub, scheme);
    return util_1.mapObjectValues(context, substitute);
}
exports.substituteInContext = substituteInContext;
function composeSubstitutions(...subs) {
    return subs.reduce((composition, sub) => ({
        ...util_1.mapObjectValues(composition, type => substituteInType(sub, type)),
        ...sub,
    }), exports.EMPTY_SUBSTITUTION);
}
exports.composeSubstitutions = composeSubstitutions;
function substituteInScheme(sub, scheme) {
    const cleanedSub = Object.keys(sub)
        .filter(typeVarName => !scheme.bound.has(typeVarName))
        .reduce((clean, currentKey) => ({
        ...clean,
        [currentKey]: sub[currentKey],
    }), exports.EMPTY_SUBSTITUTION);
    return {
        bound: scheme.bound,
        type: substituteInType(cleanedSub, scheme.type),
    };
}
exports.substituteInScheme = substituteInScheme;
//# sourceMappingURL=substitution.js.map